import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import componentBase from '../../../../../../../../src/lib/component-base';
import { formattedTime, dateFormatString } from '../../../../../../../../src/lib/date-time-format';

@componentBase('TicketTimeComponent')
export default class TicketTimeComponent extends React.Component {
  static propTypes = {
    departureInfo: PropTypes.object,
    arrivalInfo: PropTypes.object,
    status: PropTypes.string,
    redirected: PropTypes.bool,
    arrival: PropTypes.bool,
    additionalFlightInfo: PropTypes.object,
  };

  static defaultProps = {
    departureInfo: { times: { scheduled: { time: null } } },
    arrivalInfo: { times: { scheduled: { time: null } } },
    status: null,
    redirected: false,
    arrival: false,
    additionalFlightInfo: null,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      divStyle: {
        padding: '0',
      },
      borderDiv: {
        padding: '0 5px',
        margin: '18px 0',
        borderRight: '1px solid #ffffff',
      },
      titleTextStyle: {
        fontSize: '12pt',
        textAlign: 'center',
        margin: '0',
        fontWeight: '100',
      },
      timesBlockStyle: {
        width: '100%',
        height: '75px',
        borderBottom: '1px solid #ffffff',
      },
      timeBlockStyle: {
        width: '50%',
        height: '65px',
        verticalAlign: 'top',
        display: 'inline-block',
      },
      timeText: {
        fontSize: '18pt',
        margin: '0 5px',
        textAlign: 'center',
        display: 'inline-block',
        fontWeight: 700,
      },
      bigInfoText: {
        fontSize: '2em',
        margin: '7px auto',
        textAlign: 'center',
        display: 'inline-block',
        fontWeight: 700,
      },
      additionalInfoBoxStyle: {
        display: 'inline-block',
        padding: '18px 0 10px',
        textAlign: 'center',
        verticalAlign: 'top',
        width: '45%',
      },
      infoTextTitle: {
        margin: '0 0 10px',
      },
      runwayText: {
        fontSize: '10pt',
        margin: '1px 0',
      },
      divStyleMobile: {
        padding: '0',
        borderBottom: '3px solid #ffffff',
      },
    };
  }

  render() {
    let deparrTerm = 'Departure';
    let infoObject = this.props.departureInfo;
    const estActTitle = infoObject.times.estimatedActual ? infoObject.times.estimatedActual.title : '--';
    const showTimesBasedOnStatus = this.props.status !== 'Cancelled' && this.props.status !== 'Unknown' && (!this.props.redirected || (this.props.redirected && estActTitle === 'Actual'));
    let additionalInfoBox;
    let borderDiv = this.muiDefaultProps.borderDiv;
    let divStyle = this.muiDefaultProps.divStyle;

    if (this.props.arrival) {
      deparrTerm = 'Arrival';
      borderDiv = Object.assign(this.muiDefaultProps.borderDiv, { borderRight: 'none' });
      infoObject = this.props.arrivalInfo;
      additionalInfoBox = (
        <div style={this.muiDefaultProps.additionalInfoBoxStyle}>
          <p className='flight-tracker-info-text' style={this.muiDefaultProps.infoTextTitle}>
            Baggage
          </p>
          <p style={this.muiDefaultProps.bigInfoText}>
            {infoObject.baggage ? infoObject.baggage : '--'}
          </p>
        </div>
      );
    } else if (this.props.additionalFlightInfo && this.props.additionalFlightInfo.equipment) {
      borderDiv = Object.assign(this.muiDefaultProps.borderDiv, { borderRight: 'none' });
      divStyle = Object.assign(divStyle, this.muiDefaultProps.divStyleMobile);
      additionalInfoBox = (
        <div style={this.muiDefaultProps.additionalInfoBoxStyle}>
          <p className='flight-tracker-info-text' style={this.muiDefaultProps.infoTextTitle}>
            Craft Type
          </p>
          <p style={this.muiDefaultProps.bigInfoText}>
            {this.props.additionalFlightInfo.equipment.iata ? this.props.additionalFlightInfo.equipment.iata : '--'}
          </p>
        </div>
      );
    }

    const dateText = moment(infoObject.date).format(dateFormatString(this.context.currentUser));

    let scheduledTime = null;
    let scheduledTimeAMPM = null;
    let scheduledTZ = null;
    let scheduledRunway = null;

    if (infoObject.times.scheduled && infoObject.times.scheduled.time) {
      scheduledTime = formattedTime(this.context.currentUser, infoObject.times.scheduled, 'time24', 'time');
      scheduledTimeAMPM = formattedTime(this.context.currentUser, infoObject.times.scheduled, null, 'ampm');
      scheduledTZ = infoObject.times.scheduled.timezone;
      scheduledRunway = (infoObject.times.scheduled.runway ? 'Runway' : null);
    } else {
      scheduledTime = '--';
    }

    let estimatedActualTitle = null;
    let estimatedActualTime = null;
    let estimatedActualTimeAMPM = null;
    let estimatedActualTZ = null;
    let estimatedActualRunway = null;

    if (infoObject.times.estimatedActual &&
      showTimesBasedOnStatus &&
      infoObject.times.estimatedActual.time) {
      estimatedActualTitle = infoObject.times.estimatedActual.title;
      estimatedActualTime = formattedTime(this.context.currentUser, infoObject.times.estimatedActual, 'time24', 'time');
      estimatedActualTimeAMPM = formattedTime(this.context.currentUser, infoObject.times.estimatedActual, null, 'ampm');
      estimatedActualTZ = infoObject.times.estimatedActual.timezone;
      estimatedActualRunway = (infoObject.times.estimatedActual.runway ? 'Runway' : null);
    } else {
      estimatedActualTime = '--';
      estimatedActualTitle = '--';
    }

    return (
      <div>
        <div style={divStyle} className='col-xs-12 col-sm-6 col-md-4 col-lg-4'>
          <div style={borderDiv}>
            <p style={this.muiDefaultProps.titleTextStyle}>Flight {deparrTerm} Times</p>
            <p className='flight-tracker-info-text' style={this.muiDefaultProps.dateText}>{dateText}</p>
            <div style={this.muiDefaultProps.timesBlockStyle}>
              <div style={this.muiDefaultProps.timeBlockStyle}>
                <p className='flight-tracker-info-text'>Scheduled</p>
                <div style={{ textAlign: 'center' }}>
                  <p style={this.muiDefaultProps.timeText}>{scheduledTime}</p>
                  <p className='flight-tracker-time-info-text'>{scheduledTimeAMPM} {scheduledTZ}</p>
                </div>
                <p className='flight-tracker-info-text' style={this.muiDefaultProps.runwayText}>{scheduledRunway}</p>
              </div>
              <div style={this.muiDefaultProps.timeBlockStyle}>
                <p className='flight-tracker-info-text'>{estimatedActualTitle}</p>
                <div style={{ textAlign: 'center' }}>
                  <p style={this.muiDefaultProps.timeText}>{estimatedActualTime}</p>
                  <p className='flight-tracker-time-info-text'>{estimatedActualTimeAMPM} {estimatedActualTZ}</p>
                </div>
                <p className='flight-tracker-info-text' style={this.muiDefaultProps.runwayText}>{estimatedActualRunway}</p>
              </div>
            </div>
            <div className='ticket-box'>
              <p className='flight-tracker-info-text' style={this.muiDefaultProps.infoTextTitle}>Terminal</p>
              <p style={this.muiDefaultProps.bigInfoText}>{infoObject.terminal ? infoObject.terminal : '--'}</p>
            </div>
            <div className='ticket-box'>
              <p className='flight-tracker-info-text' style={this.muiDefaultProps.infoTextTitle}>Gate</p>
              <p style={this.muiDefaultProps.bigInfoText}>{infoObject.gate ? infoObject.gate : '--'}</p>
            </div>
            {additionalInfoBox}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/children/FlightTicket/TicketTimeComponent.js